import html from "html-literal";

export default () => html`
    <section id="viewNotFound">
        <div class="viewNotFound">
            <h1>View not found</h1>
        </div>
    </section>
`;